export type CreateCarVerticalReportApiResponse = /** status 201  */ CarVerticalReportResponseBody;
export type CreateCarVerticalReportApiArg = {
  vehicleId: string;
  createCarVerticalReportRequestBody: CreateCarVerticalReportRequestBody;
};
export type GetCarVerticalReportsApiResponse = /** status 200  */ CarVerticalReportResponseBody[];
export type GetCarVerticalReportsApiArg = {
  vehicleId: string;
};
export type Vin = string;
export type Alpha3 = string;
export type CarVerticalReportResponseBody = {
  id: string;
  vehicleId: string;
  reportId: string;
  vin: Vin;
  country: Alpha3;
  locale: string;
  status: 'in_progress' | 'finished' | 'failed';
  url: string | null;
  createdAt: string;
  createdBy: string;
};
export type CreateCarVerticalReportRequestBody = {
  country?: Alpha3 | null;
};
